import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PageDocsNoFilterYearAndDateContent from './PageDocsNoFilterYearAndDateContent';

function PageDocsNoFilterYearAndDate(props) {
    const { layout } = props;
    let content;
    if (layout === 'classic') {
        content = (
            <PageDocsNoFilterYearAndDateContent layout={layout} />
        );
    } else if (layout === 'full') {
        content = (
            <div className="row justify-content-center">
                <div className="col-md-12 col-lg-8 col-xl-8">
                    <PageDocsNoFilterYearAndDateContent layout={layout} />
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            {content}
        </React.Fragment>
    );
}

PageDocsNoFilterYearAndDate.propTypes = {
    layout: PropTypes.oneOf(['classic', 'full']),
};

PageDocsNoFilterYearAndDate.defaultProps = {
    layout: 'classic',
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(PageDocsNoFilterYearAndDate);
